import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  // We can customize colors, typography, etc. here if needed
  // MUI's default breakpoints are already well configured:
  // xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536
});
